const Condition = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="site-main col-sm-12 full-width">
          <article
            id="post-13"
            className="post-13 page type-page status-publish hentry"
          >
            <div className="entry-content">
              <h2 style={{ textAlign: "center" }}>
                <span style={{ color: "#f23a3a" }}>شرایط و مقررات</span>
              </h2>
              <h3 style={{ textAlign: "justify" }}>موضوع قرارداد</h3>
              <p style={{ textAlign: "justify" }}>
                موضوع این قرارداد تعیین حدود و وظایف و مسئولیت‌ های طرفین
                قرارداد برای انجام مسافرت با گشت‌های دسته‌ جمعی می‌باشد.
              </p>
              <h3 style={{ textAlign: "justify" }}>شرح خدمات</h3>
              <p style={{ textAlign: "justify" }}>
                خدمات، نرخ و زمان سفر بر اساس صفحه اصلی قرارداد بوده که این
                شرایط به آن ضمیمه می‌باشد.
              </p>
              <h3 style={{ textAlign: "justify" }}>طرفین قرارداد</h3>
              <p style={{ textAlign: "justify" }}>
                ثبت‌ نام کننده، نماینده تام‌ الاختیار افرادی است که از جانب آنها
                اقدام به ثبت‌ نام در سفر نموده و از این پس، مسافر نامیده می‌
                شود. مشخصات فردی افراد ثبت‌ نام‌شده در صفحه اصلی قرارداد درج شده
                که این شرایط به آن ضمیمه شده است.
              </p>
              <p style={{ textAlign: "justify" }}>
                دفتر خدمات مسافرتی و گردشگری مایان سفر ایرانیان با شماره مجوز
                &nbsp;45868/132/972 صادره از اداره کل میراث فرهنگی، صنایع دستی و
                گردشگری استان گلستان که از‌ این‌ پس کارگزار نامیده می‌ شود.
              </p>
              <h3 style={{ textAlign: "justify" }}>شرایط عمومی</h3>
              <p style={{ textAlign: "justify" }}>
                این پیوست می‌تواند به‌ صورت دستی تهیه شود و یا به‌ صورت
                الکترونیک توسط مسافر یا نماینده او از طریق تارنمای اختصاصی
                کارگزار تایید و با پرداخت الکترونیک، خدمات مندرج در قرارداد برای
                شرکت‌ کنندگان خریداری شود.
              </p>
              <p style={{ textAlign: "justify" }}>
                امضای قرارداد یا خرید تور به‌ صورت الکترونیک از طرف مسافر یا
                نماینده وی، به منزله مطالعه دقیق مشخصات سفر، آگاهی کامل از مفاد
                قرارداد، شرایط ابطال سفر و اطلاع از کلیه لوازم ضروری و شخصی مورد
                نیاز سفر بوده و کلیه مسئولیت‌ های ناشی از عدم توجه به مفاد این
                پیوست متوجه مسافر خواهد بود.
              </p>
              <p style={{ textAlign: "justify" }}>
                چنانچه گشت به حد نصاب مورد نظر (حداقل ۱۵ نفر) نرسد، کارگزار مجاز
                به ابطال آن، اعلام به مسافر 72 ساعت قبل از تاریخ اجرای تور و
                استرداد وجوه دریافتی از مسافر می‌باشد.
              </p>
              <p style={{ textAlign: "justify" }}>
                در طول سفر، امکان دیر یا زود شدن ساعات صرف غذا، خواب و استراحت،
                کم و زیاد شدن مدت زمان پیمایش مسیرها (با وسیله نقلیه و یا در
                راه‌پیمایی‌ها) با توجه به شرایط آب و هوایی، محیطی، محلی و یا
                حوادث غیرمترقبه وجود دارد.
              </p>
              <p style={{ textAlign: "justify" }}>
                در صورتی‌ که مقامات انتظامی یا مسئولین محلی به هر دلیلی از ورود
                مسافر به مقصد ممانعت کنند، مسافر ملزم به تبعیت از دستورات بوده و
                هیچ‌ گونه مسئولیتی بر عهده کارگزار نخواهد بود.
              </p>
              <p style={{ textAlign: "justify" }}>
                <strong>تبصره 1:</strong> در صورت بروز این اتفاق، نماینده
                کارگزار (راهنما) در صورت داشتن زمان لازم، مجاز به جابجایی سفر
                بوده و مسافر ملزم به تبعیت از راهنما خواهد بود.
              </p>
              <p style={{ textAlign: "justify" }}>
                در صورتی‌که مسافر به هر دلیل برای سایر مسافرین، سرپرست گروه،
                راهنمایان محلی و سایر افرادی که در اجرای گشت نقش دارند، مزاحمتی
                ایجاد نماید و یا مرتکب اعمال خلاف شئونات و قوانین جمهوری اسلامی
                و یا شهر مقصد شود، سرپرست گروه موظف است برحسب مورد تصمیم لازم را
                در خصوص این مسافر اخذ نموده و مراتب را جهت ضبط به کارگزار گزارش
                نماید.
              </p>
              <p style={{ textAlign: "justify" }}>
                در صورت بروز هرگونه اختلاف بین طرفین قرارداد، سازمان میراث
                فرهنگی، صنایع دستی و گردشگری مرجع رسیدگی می‌باشد و رای صادره
                مورد توافق طرفین خواهد بود.
              </p>
              <h3 style={{ textAlign: "justify" }}>اقامت</h3>
              <p style={{ textAlign: "justify" }}>
                اختصاص اتاق یک، دو و… نفره به افراد در هتل و نیز نحوه استقرار
                افراد در اقامتگاه‌های بومی یا محیط‌های طبیعی غیر از هتل (کمپ،
                کلبه، خانه محلی)، بستگی به ترکیب نفرات تور و ظرفیت هتل یا خانه
                محلی دارد. امکان استفاده از چادر یا اتاق اختصاصی برای مسافر وجود
                ندارد.
              </p>
              <p style={{ textAlign: "justify" }}>
                <strong>تبصره 2:</strong> در اکثر هتل‌ها، تخت سوم در اتاق‌های 3
                تخته از نوع سفری و یا کاناپه تاشو بوده که موقتا در اتاق 2 تخته
                گذاشته می‌شود.
              </p>
              <p style={{ textAlign: "justify" }}>
                <strong>تبصره 3:</strong> ساعت تحویل اتاق‌های هتل به هنگام ورود
                ساعت 14 و تخلیه ساعت 11 صبح بوده که مسافر موظف به رعایت آن است.
                تحویل و تخلیه اتاق قبل و بعد از ساعات اعلام شده تابع قوانین هتل
                بوده و هزینه‌های احتمالی بر عهده مسافر است.
              </p>
              <p style={{ textAlign: "justify" }}>
                <strong>تبصره 4:</strong> زمان لازم برای برپایی کمپ و جمع‌آوری
                آن مورد قبول مسافر می‌باشد.
              </p>
              <p style={{ textAlign: "justify" }}>
                استفاده از خدمات هتل از قبیل مواد خوراکی و نوشیدنی، خشک‌شویی و…
                تابع قوانین هتل بوده و پرداخت هزینه‌های انجام شده به عهده مسافر
                است.
              </p>
              <h3 style={{ textAlign: "justify" }}>
                <span style={{ color: "#f23a3a" }}>تعهدات مسافر</span>
              </h3>
              <blockquote>
                <p style={{ textAlign: "center" }}>
                  &nbsp;همراه داشتن شناسنامه عکس‌ دار و کارت ملی در تمامی سفرهای
                  داخلی الزامی است.
                </p>
              </blockquote>
              <p style={{ textAlign: "justify" }}>
                مسافر یا نماینده ایشان موظف است در هنگام ثبت‌نام، مشخصات فردی
                خود و همراهان را به‌طور صحیح و کامل ذکر نماید. بدیهی است عواقب
                بروز هرگونه مشکلی که به‌علت مغایرت در ثبت مشخصات مسافر ایجاد
                شود، متوجه مسافر و یا نماینده وی بوده و کارگزار در این رابطه
                هیچ‌گونه مسئولیتی نخواهد داشت.
              </p>
              <p style={{ textAlign: "justify" }}>
                مسئولیت مراقبت از فرزندان، اموال و مدارک شخصی به عهده مسافر بوده
                و در صورت مفقود شدن آن هیچ نوع مسئولیتی متوجه کارگزار و راهنما
                نخواهد بود.
              </p>
              <p style={{ textAlign: "justify" }}>
                مسافر موظف است در ساعات اعلام شده در برنامه‌های گشت شرکت نموده و
                در صورت عدم حضور به‌موقع به هنگام حرکت تور، شخصا متعهد قبول
                مشکلات احتمالی و پرداخت هزینه‌های مربوطه جهت پیوستن به گروه و
                ادامه برنامه تور خواهد بود و کارگزار مربوطه هیچ‌گونه مسئولیتی در
                این خصوص نخواهد داشت. زمان انتظار برای ترانسفر مسافران در
                فرودگاه حداکثر 45 دقیقه می‌باشد.
              </p>
              <p style={{ textAlign: "justify" }}>
                &nbsp;در صورت افزایش و یا تغییر نرخ حاصله در قیمت گشت، اعم از
                افزایش نرخ بلیت، هتل و سایر خدمات، با ارایه مدارک مستند از سوی
                کارگزار، مسافر موظف به پرداخت مابه‌التفاوت اعلام شده به کارگزار
                می‌باشد.
              </p>
              <p style={{ textAlign: "justify" }}>
                <strong>تبصره 5:</strong> چنانچه مسافر شرایط مندرج در ماده فوق
                را نپذیرد موظف به پرداخت هزینه ابطال مطابق با «جدول شماره 1»
                خواهد بود.
              </p>
              <p style={{ textAlign: "justify" }}>
                هزینه‌های اضافی و خارج از برنامه گشت به عهده مسافرین می‌باشد که
                لازم است در زمان اجرای گشت نسبت به پرداخت آن اقدام شود.
              </p>
              <p style={{ textAlign: "justify" }}>
                در صورت وارد نمودن خسارت به هتل‌ها، رستوران‌ها، اماکن و وسایل
                نقلیه توسط مسافر، وی شخصا مسئول پرداخت خسارت می‌باشد.
              </p>
              <p style={{ textAlign: "justify" }}>
                هرگونه هزینه و خسارت در طول سفر که به دلایل تبعیت نکردن از
                دستورات راهنما، گشت‌های خارج از خدمات کارگزار و یا عدم استفاده
                از لوازم ضروری شخصی هر سفر (مندرج در صفحه ویژه هر سفر در تارنمای
                اختصاصی کارگزار) به‌وجود آید تماما متوجه مسافر خواهد بود.
              </p>
              <p style={{ textAlign: "justify" }}>
                مسافر یا نماینده ایشان موظف است بر اساس سطح توانایی جسمی خود و
                همراهان در تور متناسب با سختی سفر، ثبت‌نام نماید. همچنین در صورت
                داشتن بیماری خاص، نیاز به مصرف داروی تجویزشده از سوی پزشک و یا
                استفاده از تجهیزات پزشکی خاص، علاوه بر اطلاع‌رسانی به مسوول فروش
                پیش از ثبت‌نام، موضوع را کتبا نیز به شرکت اعلام نماید. در صورت
                موافقت شرکت با حضور ایشان در تور، مسافر موظف است داروها و
                تجهیزات مورد نیاز را به همراه داشته باشد.
              </p>
              <p style={{ textAlign: "justify" }}>
                <strong>تبصره 6:</strong> مسافر یا نماینده ایشان با ثبت‌نام در
                هر سفر، مسوولیت حضور در سفر با توجه وضعیت جسمانی خود و همراهان
                خود را می‌پذیرد و بروز هرگونه مشکل و یا هزینه ناشی از عدم آمادگی
                جسمانی یا عدم آگاهی مسافر از وضعیت جسمانی خود و یا امراض احتمالی
                مسافر در طول سفر به عهده مسافر خواهد بود.
              </p>
              <p style={{ textAlign: "justify" }}>
                مسافر موظف است به هنگام ثبت‌نام، حداقل 50% هزینه کل تور را
                پرداخت نماید. در صورت رزرو تور با پیش‌پرداخت، مسافر می‌بایست
                حداکثر تا یک هفته پیش از پایان سال برای سفرهای نوروزی و تا یک
                هفته پیش از اجرای تور برای سایر سفرها، اقدام به تسویه حساب
                نماید. عدم تسویه حساب، به منزله انصراف از سفر است و هزینه ابطال
                مطابق با «جدول شماره 1» محاسبه خواهد شد.
              </p>
              <h3 style={{ textAlign: "justify" }}>
                <span style={{ color: "#f23a3a" }}>تعهدات کارگزار</span>
              </h3>
              <p style={{ textAlign: "justify" }}>
                کارگزار موظف است نرخ و کلیه برنامه‌های خدمات گشت را به‌صورت
                بروشور، کتبی و یا در تارنمای اختصاصی خود به مسافر اعلام نماید.
                در صورتی‌که برنامه ارایه شده توسط کارگزار در طول سفر عینا به
                اجرا گذاشته نشود، مسافر مجاز است موارد را با ارایه دلایل مستدل
                به کارگزار اعلام نموده و کارگزار موظف به جلب رضایت مسافر است.
              </p>
              <p style={{ textAlign: "justify" }}>
                <strong>تبصره 7:</strong> در صورت وقوع هرگونه پیشامد غیرمنتظره
                از قبیل شرایط فوق‌العاده جوی، جنگ، شورش و مشکلاتی که از کنترل
                کارگزار خارج بوده و سبب ابطال یا تغییر برنامه گشت و یا مسافر شود
                مسئولیتی متوجه کارگزار نخواهد بود.
              </p>
              <p style={{ textAlign: "justify" }}>
                در صورت عدم امکان رزرو هتل مندرج در این قرارداد، کارگزار موظف به
                رزرو هتلی با همان درجه و کیفیت می‌باشد.
              </p>
              <p style={{ textAlign: "justify" }}>
                کارگزار موظف است در گشت‌ها، از راهنمای مورد تایید سازمان میراث
                فرهنگی، صنایع دستی و گردشگری استفاده نماید.
              </p>
              <p style={{ textAlign: "justify" }}>
                در سفرهای زمینی، اگر وسیله نقلیه به هر دلیل و در هر قسمت از سفر
                از حرکت بازایستد، جایگزینی وسیله نقلیه جدید و هرگونه هزینه دیگری
                که بابت تاخیرایجاد شده است بر عهده کارگزار بوده و زمان لازم جهت
                تامین وسیله نقلیه جدید و تاخیردر اجرای سفر نیز مورد قبول مسافر
                است.
              </p>
              <p style={{ textAlign: "justify" }}>
                <strong>تبصره 8:</strong> در مورد تاخیر یا کنسلی در سفرهای
                هوایی، ریلی و دریایی بر اساس قوانین سازمان مربوطه عمل خواهد شد.
              </p>
              <blockquote>
                <p style={{ textAlign: "justify" }}>
                  وسایل نقلیه اصلی و محلی به تناسب تعداد مسافران و نوع مسیر
                  (آسفالت، خاکی، کوهستانی و…) به تشخیص کارگزار انتخاب شده و
                  کارگزار موظف است قبل از سفر در خصوص نوع وسایل نقلیه در تارنمای
                  خود اطلاع‌ رسانی نماید.
                </p>
              </blockquote>
              <p style={{ textAlign: "justify" }}>
                کارگزار موظف است بیمه مسئولیت مدنی را بر طبق مندرجات این قرارداد
                در مورد مسافر اعمال نماید.
              </p>
              <p style={{ textAlign: "justify" }}>
                <strong>تبصره 9:</strong> در صورت بروز هرگونه حادثه‌ای در طول
                سفر، مسافر باید بر اساس شرایط بیمه تحت پوشش اقدام نماید. در این
                خصوص کارگزار همکاری لازم را به عمل خواهد آورد.
              </p>
              <p style={{ textAlign: "justify" }}>
                <strong>تبصره 10:</strong> در صورت بروز هرگونه حادثه که منجر به
                خسارت جسمانی در طول سفر گردد، مسافر خود موظف به پرداخت هزینه‌های
                امداد و نجات و درمان می‌باشد. بدیهی است مسافر می‌تواند پس از طی
                مراحل قانونی و پزشکی با دریافت گزارش از کارگزار به شرکت بیمه
                مراجعه و طبق تعرفه‌های بیمه اقدام به دریافت خسارت نماید. در خصوص
                هزینه‌های درمانی مازاد بر بیمه هیچ‌گونه مسئولیتی متوجه کارگزار
                نخواهد بود.
              </p>
              <p style={{ textAlign: "justify" }}>
                <strong>تبصره 11:</strong> در صورت درخواست مسافر برای اعمال
                بیمه‌های تکمیلی و حوادث، کارگزار باید با دریافت هزینه آن از
                مسافر، نسبت به صدور بیمه‌های درخواستی اقدام نماید.
              </p>
              <p style={{ textAlign: "justify" }}>
                <strong>تبصره 12:</strong> در صورتی‌که مسافر به هر دلیل جدا از
                برنامه سفر کارگزار به گروه ملحق و یا قبل از پایان سفر از گروه
                جدا شود، بیمه مسافر فقط از ابتدای الحاق وی به سفر و یا تا زمان
                انفصال وی از سفر معتبر بوده و فقط در مدت زمان حضور وی در سفر
                اعمال خواهد شد و در خارج از این زمان کارگزار مسئولیتی در قبال
                بیمه مسافر نخواهد داشت.
              </p>
              <h3 style={{ textAlign: "justify" }}>
                <span style={{ color: "#f23a3a" }}>
                  نرخ و شرایط ابطال گشت‌ها توسط مسافر
                </span>
              </h3>
              <p style={{ textAlign: "justify" }}>
                درخواست انصراف از سفر باید به‌صورت حضوری، ارسال فکس و یا ایمیل
                توسط شخص مسافر و یا نماینده رسمی وی انجام شود. جریمه کنسل نمودن
                تور طبق «جدول شماره 1» از کل مبلغ گشت کسر و مابقی وجوه به مسافر
                پرداخت خواهد شد.
              </p>
              <p style={{ textAlign: "justify" }}>
                <strong>تبصره 13:</strong> در ثبت‌نام‌های گروهی فقط فردی که به
                نمایندگی از سوی مسافران اقدام به ثبت‌نام و عقد قرارداد نموده
                مجاز به مراجعه به کارگزار جهت پیگیری، ابطال و یا دریافت وجوه
                پرداختی می‌باشد و سایر مسافرین در این خصوص مجاز به مراجعه به
                کارگزار نمی‌باشند.
              </p>
              <p style={{ textAlign: "justify" }}>
                <strong>تبصره 14:</strong> در صورت چارتر (دربست) بودن محل اقامت،
                بلیط هواپیما و یا قطار جرایم ابطالی با ارایه مدارک بر اساس
                مقررات مربوطه اخذ خواهد شد.
              </p>
              <p style={{ textAlign: "justify" }}>
                <strong>تبصره 15:</strong> جریمه کنسلی از قیمت نهایی شامل هر فرد
                ثبت‌نام شده محاسبه و کسر می‌گردد.
              </p>
              <p style={{ textAlign: "justify" }}>
                <strong>تبصره 16:</strong> در صورتی‌ که وسیله نقلیه مورد استفاده
                در سفر هواپیما یا قطار باشد، علاوه بر مبالغ درج شده در «جدول
                شماره 1»، جریمه ابطال بلیط هواپیما یا قطار نیز دریافت خواهد شد.
              </p>
              <h3 style={{ textAlign: "center" }}>
                <span style={{ color: "#f23a3a" }}>
                  جدول شماره 1: جریمه کنسلی گشت‌ های داخلی
                </span>
              </h3>
              <p style={{ textAlign: "center" }}></p>
              <div
                id="tablepress-35_wrapper"
                className="dataTables_wrapper no-footer"
              >
                <table
                  id="tablepress-35"
                  className="tablepress tablepress-id-35 dataTable no-footer"
                  role="grid"
                >
                  <thead>
                    <tr className="row-1 odd" role="row">
                      <th
                        className="column-1 sorting_disabled"
                        rowSpan={1}
                        colSpan={1}
                        style={{ width: 424 }}
                      >
                        گشت‌ های عادی
                      </th>
                      <th
                        className="column-2 sorting_disabled"
                        rowSpan={1}
                        colSpan={1}
                        style={{ width: 135 }}
                      >
                        &nbsp;
                      </th>
                      <th
                        className="column-3 sorting_disabled"
                        rowSpan={1}
                        colSpan={1}
                        style={{ width: 381 }}
                      >
                        گشت‌ های نوروزی
                      </th>
                      <th
                        className="column-4 sorting_disabled"
                        rowSpan={1}
                        colSpan={1}
                        style={{ width: 135 }}
                      >
                        &nbsp;
                      </th>
                    </tr>
                  </thead>
                  <tbody className="row-hover">
                    <tr className="row-2 even" role="row">
                      <td className="column-1">زمان ابطال توسط مسافر</td>
                      <td className="column-2">درصد جریمه</td>
                      <td className="column-3" />
                      <td className="column-4">درصد جریمه</td>
                    </tr>
                    <tr className="row-3 odd" role="row">
                      <td className="column-1">
                        از زمان ثبت‌ نام تا 30 روز قبل از سفر
                      </td>
                      <td className="column-2">5 %</td>
                      <td className="column-3">
                        از زمان ثبت‌ نام تا 30 روز قبل از سفر
                      </td>
                      <td className="column-4">5 %</td>
                    </tr>
                    <tr className="row-4 even" role="row">
                      <td className="column-1">از 29 تا 15 روز قبل از سفر</td>
                      <td className="column-2">10 %</td>
                      <td className="column-3">از 29 تا 25 روز قبل از سفر</td>
                      <td className="column-4">30 %</td>
                    </tr>
                    <tr className="row-5 odd" role="row">
                      <td className="column-1">از 14 تا 7 روز قبل از سفر</td>
                      <td className="column-2">20 %</td>
                      <td className="column-3">از 24 تا 20 روز قبل از سفر</td>
                      <td className="column-4">35 %</td>
                    </tr>
                    <tr className="row-6 even" role="row">
                      <td className="column-1">از 6 تا 3 روز قبل از سفر</td>
                      <td className="column-2">25 %</td>
                      <td className="column-3">از 19 تا 10 روز قبل از سفر</td>
                      <td className="column-4">40 %</td>
                    </tr>
                    <tr className="row-7 odd" role="row">
                      <td className="column-1">از 2 تا 1 روز قبل از سفر</td>
                      <td className="column-2">50 %</td>
                      <td className="column-3">از 9 تا 6 روز قبل از سفر</td>
                      <td className="column-4">45 %</td>
                    </tr>
                    <tr className="row-8 even" role="row">
                      <td className="column-1">از 24 تا 12 ساعت قبل از سفر</td>
                      <td className="column-2">70 %</td>
                      <td className="column-3">از 5 تا 3 روز قبل از سفر</td>
                      <td className="column-4">70 %</td>
                    </tr>
                    <tr className="row-9 odd" role="row">
                      <td className="column-1">
                        از 12 ساعت قبل و یا عدم حضور در سفر
                      </td>
                      <td className="column-2">90 %</td>
                      <td className="column-3">
                        از 2 روز قبل و یا عدم حضور در سفر
                      </td>
                      <td className="column-4">90 %</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              {/* #tablepress-35 from cache */}
              <p />
              <h3>
                <span style={{ color: "#f23a3a" }}>نکات مهم:</span>
              </h3>
              <p style={{ textAlign: "justify" }}>
                جریمه ابطال گشت های یکروزه&nbsp; مطابق “جدول 1 ” بوده و فقط
                جریمه ابطال گشت، کمتر از 12 ساعت قبل از حرکت 100% می باشد.
              </p>
              <p style={{ textAlign: "justify" }}>
                گشت‌های نوروزی گشت‌هایی هستند که در فاصله زمانی 25 اسفند لغایت
                15 فروردین سال بعد برگزار می‌ گردد.
              </p>
              <p style={{ textAlign: "justify" }}>
                این قرارداد در 26 ماده و 16 تبصره، در 2 نسخه با متن و ارزش
                یکسان، بر اساس مواد 230، 221 و 10 قانون مدنی تنظیم، امضا و
                مبادله گردیده است.
              </p>
            </div>
            {/* .entry-content */}
            <footer className="entry-footer"></footer>
            {/* .entry-footer */}
          </article>
          {/* #post-## */}
        </div>
      </div>
    </div>
  );
};

export default Condition;
